// extracted by mini-css-extract-plugin
module.exports = {"socialMediaList":"styles_socialMediaList__1PwBj"};